import iphoneX from "./iphone-x";
import iphone7 from "./iphone-7";
import iphone5c from "./iphone-5c";
import galaxyS8 from "./galaxy-s8";
import pixel from "./pixel";
import n220 from "./220";

export default {
	id: "phones",
	title: "Phones",
	width: "5em",
	height: "11em",
	items: [iphoneX, iphone7, galaxyS8, iphone5c, pixel, n220]
};
